export default __webpack_public_path__ + "static/media/logo1.aa3acad7.jpg";